/*=========================================================================================
  File Name: module-confirm-business-mutations.js
  Description: Confirm Business Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */

export default {
    updateConfirmListBusiness(state, res) {
        state.ConfirmListBusiness = res.Data;
    },

    updateConfirmBusinessTotal(state, res) {
        state.Total = res;
    },

    // updateTotalPage(state, res) {
    //     state.Total = res;
    // },

    updateLoadingTotalRecords(state, res) {
        state.IsLoading = res;
    },
};